import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { ProblemAgitation } from '../components/ProblemAgitation';
import { HardTruth } from '../components/HardTruth';
import { HowItWorks } from '../components/HowItWorks';
import { ReportPreview } from '../components/ReportPreview';
import { WhyTwoOpinions } from '../components/WhyTwoOpinions';
import { Experts } from '../components/Experts';
import { Pricing } from '../components/Pricing';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export const Home = () => {
  return <div className="min-h-screen bg-offwhite" data-id="element-342">
      <Header data-id="element-343" />
      <main data-id="element-344">
        <Hero data-id="element-345" />
        <ProblemAgitation data-id="element-346" />
        <HardTruth data-id="element-347" />
        <HowItWorks data-id="element-348" />
        <ReportPreview data-id="element-349" />
        <WhyTwoOpinions data-id="element-350" />
        <Experts data-id="element-351" />
        <Pricing data-id="element-352" />
        <FAQ data-id="element-353" />
        <FinalCTA data-id="element-354" />
      </main>
      <Footer data-id="element-355" />
    </div>;
};